import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';
import { api } from '../utils';
import PropertyBox from '../components/PropertyBox';

const PlayWithExisted = ({ boxId = undefined }) => {
  const [sampleProperties, setSampleProperties] = useState([]);

  const requestSampleProperties = useCallback(async () => {
    const { data } = await api.get('/sample-properties');
    setSampleProperties(data || []);
  }, []);

  useEffect(() => {
    requestSampleProperties();
  }, []);

  const handleSamplePropertyPress = useCallback(
    (buildingId, name) => () => {
      if (window?.RGWidgetOpts?.openWidget && buildingId) {
        window?.RGWidgetOpts?.openWidget(buildingId, name);
      } else {
        window?.console.error('RGWidgetOpts is not defined');
      }
    },
    []
  );

  return (
    <div id={boxId} className={styles.root}>
      {sampleProperties.length > 0 && (
        <div className={styles.sampleList}>
          <h3 className={styles.title}>Try the bot for one of the properties listed below</h3>
          <div className={styles.boxes}>
            {sampleProperties.map(({ name, address, botID }) => {
              if (!botID) return null;
              return (
                <div key={botID}>
                  <PropertyBox
                    title={name}
                    desc={address}
                    onPress={handleSamplePropertyPress(botID, name)}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

PlayWithExisted.propTypes = {
  boxId: PropTypes.string,
};

export default PlayWithExisted;
